type ServiceDetailProps = {
  /** Zero-padded index, e.g. "01". */
  n: string;
  title: string;
  description: string;
};

/**
 * Numbered two-column service block for the Services page, matching the
 * mockup's `.sblock`: number + title in the left column, description in the
 * right column. Stacks on mobile, two columns from `md`. Renders with a
 * hairline bottom border that drops on the last sibling in a list (mockup's
 * last `.sblock{border-bottom:0}`).
 */
export const ServiceDetail = ({ n, title, description }: ServiceDetailProps) => (
  <div className="border-line-soft grid grid-cols-1 gap-3.5 border-b py-8 last:border-b-0 md:grid-cols-[0.9fr_1.1fr] md:gap-10 md:py-11">
    <div>
      <span className="font-display text-primary text-[15px] [font-variant-numeric:tabular-nums]">
        {n}
      </span>
      <h2 className="mt-1.5 text-[clamp(26px,6vw,36px)]">{title}</h2>
    </div>
    <div>
      <p className="text-ink-soft">{description}</p>
    </div>
  </div>
);
